module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-netlify-cms@5.14.0_012b06f0f652ed375786a810e5e5234b/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/home/runner/work/rg-web/rg-web/src/cms/index.js","manualInit":true},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@3.14.0_gatsby@3.14.6/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"793b4782a5b41a3d894fe68162d7fefc"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
